import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = {
  key: 0,
  class: "ctx-modelo"
}
const _hoisted_4 = { class: "subtitulo" }
const _hoisted_5 = {
  key: 0,
  class: "info"
}
const _hoisted_6 = { class: "controles" }
const _hoisted_7 = { class: "tabs" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "acciones-exp" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "panel-ocultar"
}
const _hoisted_16 = { class: "chk" }
const _hoisted_17 = ["checked", "onChange"]
const _hoisted_18 = { class: "panel-caracts" }
const _hoisted_19 = ["checked", "onChange"]
const _hoisted_20 = { class: "contenedor-tabla" }
const _hoisted_21 = { class: "lista-tabla general" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["rowspan"]
const _hoisted_24 = ["rowspan"]
const _hoisted_25 = ["rowspan"]
const _hoisted_26 = ["rowspan"]
const _hoisted_27 = ["rowspan"]
const _hoisted_28 = { class: "nombre" }
const _hoisted_29 = { class: "col-num" }
const _hoisted_30 = ["min", "max", "value", "onChange"]
const _hoisted_31 = ["rowspan"]
const _hoisted_32 = {
  key: 6,
  class: "col-num"
}
const _hoisted_33 = ["rowspan"]
const _hoisted_34 = {
  key: 8,
  class: "col-num"
}
const _hoisted_35 = {
  key: 1,
  class: "fila-subtotal"
}
const _hoisted_36 = { colspan: "7" }
const _hoisted_37 = { class: "col-num" }
const _hoisted_38 = { class: "col-num" }
const _hoisted_39 = { class: "col-num" }
const _hoisted_40 = {
  key: 0,
  class: "fila-global"
}
const _hoisted_41 = { class: "col-num" }
const _hoisted_42 = { class: "col-num" }
const _hoisted_43 = { class: "resumen-cards" }
const _hoisted_44 = { class: "resumen-titulo" }
const _hoisted_45 = { class: "resumen-fila" }
const _hoisted_46 = { class: "resumen-fila" }
const _hoisted_47 = { class: "resumen-fila" }
const _hoisted_48 = { class: "resumen-fila" }
const _hoisted_49 = { class: "contenedor-tabla" }
const _hoisted_50 = { class: "lista-tabla semaforo" }
const _hoisted_51 = { class: "fila-caract-head" }
const _hoisted_52 = { colspan: "6" }
const _hoisted_53 = { class: "nombre" }
const _hoisted_54 = { class: "col-num" }
const _hoisted_55 = { class: "col-sem" }
const _hoisted_56 = {
  key: 0,
  class: "marca fuerte"
}
const _hoisted_57 = { class: "col-sem" }
const _hoisted_58 = {
  key: 0,
  class: "marca debil"
}
const _hoisted_59 = { class: "col-sem" }
const _hoisted_60 = {
  key: 0,
  class: "marca muy_debil"
}
const _hoisted_61 = { class: "contenedor-tabla" }
const _hoisted_62 = { class: "lista-tabla estructura" }
const _hoisted_63 = { class: "cod" }
const _hoisted_64 = { class: "nombre" }
const _hoisted_65 = { class: "col-num" }
const _hoisted_66 = { class: "col-num" }
const _hoisted_67 = { class: "col-num" }
const _hoisted_68 = { class: "graficos" }
const _hoisted_69 = { class: "grafico-titulo" }
const _hoisted_70 = ["viewBox"]
const _hoisted_71 = ["x2"]
const _hoisted_72 = ["y1", "y2"]
const _hoisted_73 = ["y"]
const _hoisted_74 = ["x", "y", "width", "height", "fill"]
const _hoisted_75 = ["x", "y"]
const _hoisted_76 = ["x"]
const _hoisted_77 = {
  key: 0,
  class: "mensaje-vacio"
}

import { ref, computed, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useGestionResultadosAutoevaluacion } from '@/store/GestionResultadosAutoevaluacion'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'
import { useGestionEvaluacionesIndicadores } from '@/store/GestionEvaluacionesIndicadores'
import useAutenticar from '@/store/IngresoAutenticar'
import type { NodoResultado, Clasificacion } from '@/interfaces/ResultadosAutoevaluacion'
import { exportarCSV, exportarExcel, exportarPDF, type TablaExport, type Celda } from '@/utils/exportUtils'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import { getProcesoByIdService } from '@/services/ProcesoAutoevaluacionService'
import { getResultadoIndicadorService } from '@/services/ResultadosService'
import { getEvaluacionesIndicadorService } from '@/services/EvaluacionIndicadorService'

interface FilaGeneral {
  key: string
  tipo: 'aspecto' | 'subtotal'
  factor: NodoResultado
  factorRowspan?: number
  mostrarFactor?: boolean
  caract?: NodoResultado
  caractRowspan?: number
  mostrarCaract?: boolean
  aspecto?: NodoResultado | null
}

interface FilaEstructura {
  key: string
  codigo: string
  tipo: string
  tipoNivel: number
  sangria: number
  nombre: string
  peso: number | null
  valoracion: number | null
  pct: number | null
  grado: string | null
  clasificacion: Clasificacion
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ResultadosAutoevaluacionView',
  setup(__props) {

/**
 * Informe MAAM de resultados de una ejecución.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/ejecucion/:id_ejecucion/resultados` (ResultadosAutoevaluacion) — permiso `calificacion.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const idEjecucion = Number(route.params.id_ejecucion)
const store = useGestionResultadosAutoevaluacion()
const indicadorInstrumentoStore = useGestionIndicadorInstrumentos()
const evaluacionesStore = useGestionEvaluacionesIndicadores()
const authStore = useAutenticar()
const nombreVersion = ref('')
const idVersion = ref<number | null>(null)

// Estado para edición de notas históricas
const idsConInstrumento = ref<Set<number>>(new Set())
const relacionesCargadas = ref(false)
const modoEdicion = ref(false)
const guardandoCambios = ref(false)
const notasEditadas = ref<Record<number, number>>({})

const mensajeVisible = ref(false)
const mensajeTexto   = ref('')
const mensajeTipo    = ref<'positivo' | 'error'>('error')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error' = 'error') {
  mensajeTexto.value  = texto
  mensajeTipo.value   = tipo
  mensajeVisible.value = true
}

watch(() => store.error, (val) => { if (val) mostrarMensaje(val, 'error') })

const enfoque = ref<'general' | 'fortalezas' | 'estructura' | 'graficos'>('general')
const enfoques = [
  { id: 'general', label: 'Vista general' },
  { id: 'fortalezas', label: 'Fortalezas y debilidades' },
  { id: 'estructura', label: 'Estructura completa' },
  { id: 'graficos', label: 'Gráficos' }
] as const

const mostrarPanel = ref(false)
const ocultos = ref<Set<number>>(new Set())

const datos = computed(() => store.resultados)
const escala = computed(() => datos.value?.escala_max || 5)
const escalaMinimo = computed(() => (datos.value?.escala_max ?? 5) >= 10 ? 1 : 0)

// Ordena ordinales numéricamente: "1.10" > "1.2", "2" > "1"
function cmpOrdinal(a?: string | null, b?: string | null): number {
  const pa = (a ?? '').split('.').map(s => parseInt(s) || 0)
  const pb = (b ?? '').split('.').map(s => parseInt(s) || 0)
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0)
    if (d !== 0) return d
  }
  return 0
}

function sortNodo(n: NodoResultado): NodoResultado {
  return {
    ...n,
    hijos: [...n.hijos].sort((a, b) => cmpOrdinal(a.ordinal, b.ordinal)).map(sortNodo)
  }
}

const factoresOrdenados = computed<NodoResultado[]>(() =>
  [...(datos.value?.factores ?? [])]
    .sort((a, b) => cmpOrdinal(a.ordinal, b.ordinal))
    .map(sortNodo)
)

function estaOculto(id: number): boolean {
  return ocultos.value.has(id)
}
function toggle(id: number): void {
  const s = new Set(ocultos.value)
  s.has(id) ? s.delete(id) : s.add(id)
  ocultos.value = s
}

//  Recolectores 

function recolectarHojas(nodo: NodoResultado): NodoResultado[] {
  if (estaOculto(nodo.id_componente)) return []
  if (nodo.es_hoja || !nodo.hijos.length) return [nodo]
  const hojas: NodoResultado[] = []
  for (const h of nodo.hijos) hojas.push(...recolectarHojas(h))
  return hojas
}

const factoresVisibles = computed(() =>
  factoresOrdenados.value.filter(f => !estaOculto(f.id_componente))
)

// Hoja general (con rowspans y subtotales) 

const filasGenerales = computed<FilaGeneral[]>(() => {
  const filas: FilaGeneral[] = []
  let n = 0
  for (const factor of factoresVisibles.value) {
    const caracts = (factor.hijos.length ? factor.hijos : [factor]).filter(c => !estaOculto(c.id_componente))
    const grupos = caracts.map(c => {
      const hojas = recolectarHojas(c)
      return { nodo: c, hojas: hojas.length ? hojas : [null] as (NodoResultado | null)[] }
    })
    const totalFactor = grupos.reduce((s, g) => s + g.hojas.length, 0) || 1
    let primeraFactor = true
    for (const g of grupos) {
      let primeraCaract = true
      for (const hoja of g.hojas) {
        filas.push({
          key: `a${n++}`,
          tipo: 'aspecto',
          factor,
          factorRowspan: totalFactor,
          mostrarFactor: primeraFactor,
          caract: g.nodo === factor ? undefined : g.nodo,
          caractRowspan: g.hojas.length,
          mostrarCaract: primeraCaract,
          aspecto: hoja
        })
        primeraFactor = false
        primeraCaract = false
      }
    }
    filas.push({ key: `s${factor.id_componente}`, tipo: 'subtotal', factor })
  }
  return filas
})

// Hoja fortalezas/debilidades (semáforo) 

const gruposSemaforo = computed(() => {
  const grupos: { id: number; ordinal: string | null; nombre: string; hojas: NodoResultado[] }[] = []
  for (const factor of factoresVisibles.value) {
    const caracts = factor.hijos.length ? factor.hijos : [factor]
    for (const c of caracts) {
      if (estaOculto(c.id_componente)) continue
      const hojas = recolectarHojas(c)
      if (hojas.length) grupos.push({ id: c.id_componente, ordinal: c.ordinal, nombre: c.nombre, hojas })
    }
  }
  return grupos
})

//  Hoja estructura completa 

const filasEstructura = computed<FilaEstructura[]>(() => {
  const filas: FilaEstructura[] = []
  let n = 0
  const tipoPorNivel = (nivel: number) => (nivel === 1 ? 'Factor' : nivel === 2 ? 'Característica' : 'Subnivel')

  const walk = (nodo: NodoResultado) => {
    if (estaOculto(nodo.id_componente)) return

    // "Aspecto" (conserva la ponderación de la hoja), sin duplicar.
    if (nodo.es_hoja && nodo.aspectos.length <= 1) {
      filas.push({
        key: `e${n++}`,
        codigo: nodo.ordinal ?? '',
        tipo: 'Aspecto',
        tipoNivel: 3,
        sangria: nodo.nivel - 1,
        nombre: nodo.nombre,
        peso: nodo.peso,
        valoracion: nodo.valoracion,
        pct: nodo.pct,
        grado: nodo.grado,
        clasificacion: nodo.clasificacion
      })
      return
    }

    filas.push({
      key: `e${n++}`,
      codigo: nodo.ordinal ?? '',
      tipo: tipoPorNivel(nodo.nivel),
      tipoNivel: Math.min(nodo.nivel, 3),
      sangria: nodo.nivel - 1,
      nombre: nodo.nombre,
      peso: nodo.peso,
      valoracion: nodo.valoracion,
      pct: nodo.pct,
      grado: nodo.grado,
      clasificacion: nodo.clasificacion
    })
    // Hoja con varios aspectos: la hoja agrupa y cada indicador es un aspecto.
    for (const a of nodo.aspectos) {
      filas.push({
        key: `e${n++}`,
        codigo: a.ordinal ?? '',
        tipo: 'Aspecto',
        tipoNivel: 3,
        sangria: nodo.nivel,
        nombre: a.nombre,
        peso: null,
        valoracion: a.valoracion,
        pct: a.pct,
        grado: a.grado,
        clasificacion: a.clasificacion
      })
    }
    for (const h of nodo.hijos) walk(h)
  }
  for (const f of factoresVisibles.value) walk(f)
  return filas
})

//  Gráficos 

const ejeTicks = computed(() => {
  const max = Math.ceil(escala.value)
  const paso = max <= 5 ? 1 : 2
  const ticks: number[] = []
  for (let t = 0; t <= max; t += paso) ticks.push(t)
  return ticks
})
function yPos(v: number): number {
  const max = escala.value || 5
  return 160 - (Math.max(0, Math.min(max, v)) / max) * 150
}

const datosGraficos = computed(() =>
  factoresVisibles.value.map(f => {
    const caracts = (f.hijos.length ? f.hijos : [f]).filter(c => !estaOculto(c.id_componente))
    const barras = caracts.map(c => ({ ordinal: c.ordinal, valor: c.valoracion, clasificacion: c.clasificacion }))
    const paso = 62
    const width = Math.max(240, 60 + barras.length * paso)
    return { id: f.id_componente, ordinal: f.ordinal, nombre: f.nombre, barras, paso, anchoBarra: 38, width }
  }).filter(g => g.barras.length)
)

//  Formato / colores

// Quita el primer segmento del ordinal para la visualización:
// "1.1" → "1", "1.2" → "2", "1.1.1" → "1.1", "1" → "1"
function fmtOrdinal(ordinal?: string | null): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length <= 1 ? ordinal : parts.slice(1).join('.')
}

function fmtVal(v: number | null | undefined): string {
  return v === null || v === undefined ? '—' : v.toFixed(2)
}
function fmtPct(v: number | null | undefined): string {
  return v === null || v === undefined ? '—' : `${v.toFixed(1)}%`
}
function fmtPeso(v: number | null | undefined): string {
  return v === null || v === undefined ? '—' : `${(+v).toFixed(v % 1 === 0 ? 0 : 2)}%`
}
function clasClase(c: Clasificacion): string {
  return `clas-${c}`
}
function clasLabel(c: Clasificacion): string {
  return { fuerte: 'Fuerte', debil: 'Débil', muy_debil: 'Muy débil', no_aplica: 'No aplica' }[c]
}
function clasColor(c: Clasificacion): string {
  return { fuerte: '#28a745', debil: '#ffc107', muy_debil: '#dc3545', no_aplica: '#c9c9c9' }[c]
}
function nivelLabel(k: string): string {
  return { factores: 'Factores', caracteristicas: 'Características', aspectos: 'Aspectos' }[k] ?? k
}
function pctResumen(n: number, total: number): string {
  return total > 0 ? `${((n / total) * 100).toFixed(1)}%` : '0%'
}

// Exportación 

function construirTabla(): { tabla: TablaExport; clasFilas: (string | null)[]; merges?: { startRow: number; endRow: number; startCol: number; endCol: number }[] } {
  const d = datos.value!
  const base = `resultados_ejec${idEjecucion}`
  if (enfoque.value === 'general') {
    const headers = ['N°', 'Factor', 'Ponderación', 'N° C.', 'Característica', 'N° A.', 'Aspecto', 'Valoración', 'Gradación', '% Prom. Ponderado', 'Nivel de Cumplimiento']
    const rows: Celda[][] = []
    const clas: (string | null)[] = []
    const merges: { startRow: number; endRow: number; startCol: number; endCol: number }[] = []
    let rowIdx = 0
    for (const fila of filasGenerales.value) {
      if (fila.tipo === 'aspecto') {
        // Registrar rangos de fusión para factor (cols 0-2) y característica (cols 3,4,8,9)
        if (fila.mostrarFactor && (fila.factorRowspan ?? 1) > 1) {
          const span = fila.factorRowspan!
          ;[0, 1, 2].forEach(c => merges.push({ startRow: rowIdx, endRow: rowIdx + span - 1, startCol: c, endCol: c }))
        }
        if (fila.caract && fila.mostrarCaract && (fila.caractRowspan ?? 1) > 1) {
          const span = fila.caractRowspan!
          ;[3, 4, 8, 9].forEach(c => merges.push({ startRow: rowIdx, endRow: rowIdx + span - 1, startCol: c, endCol: c }))
        }
        rows.push([
          fila.mostrarFactor ? fmtOrdinal(fila.factor.ordinal) : null,
          fila.mostrarFactor ? fila.factor.nombre : null,
          fila.mostrarFactor ? fmtPeso(fila.factor.peso) : null,
          fila.caract ? (fila.mostrarCaract ? fmtOrdinal(fila.caract.ordinal) : null) : '',
          fila.caract ? (fila.mostrarCaract ? fila.caract.nombre : null) : '—',
          fmtOrdinal(fila.aspecto?.ordinal),
          fila.aspecto?.nombre ?? '—',
          fmtVal(fila.aspecto?.valoracion ?? null),
          fila.caract ? (fila.mostrarCaract ? fmtPeso(fila.caract.peso) : null) : '—',
          fila.caract ? (fila.mostrarCaract ? fmtVal(fila.caract.valoracion) : null) : '—',
          fila.aspecto?.grado ?? '—'
        ])
        clas.push(fila.aspecto?.clasificacion ?? null)
      } else {
        rows.push([
          `SUBTOTAL FACTOR ${fmtOrdinal(fila.factor.ordinal)} · ${fila.factor.nombre}`,
          '', '', '', '', '', '',
          fmtVal(fila.factor.valoracion),
          fmtPeso(fila.factor.peso),
          fmtPct(fila.factor.pct),
          fila.factor.grado ?? '—'
        ])
        merges.push({ startRow: rowIdx, endRow: rowIdx, startCol: 0, endCol: 6 })
        clas.push('subtotal')
      }
      rowIdx++
    }
    if (d.global) {
      rows.push(['CALIFICACIÓN GLOBAL DEL MODELO', '', '', '', '', '', '', fmtVal(d.global.valoracion), '100%', fmtPct(d.global.pct), d.global.grado ?? '—'])
      merges.push({ startRow: rowIdx, endRow: rowIdx, startCol: 0, endCol: 6 })
      clas.push('global')
    }
    return { tabla: { nombre: `${base}_general`, titulo: 'Resultados de Autoevaluación', headers, rows }, clasFilas: clas, merges }
  }
  if (enfoque.value === 'fortalezas') {
    const headers = ['Característica', 'Aspecto', 'Valoración', 'Clasificación']
    const rows: Celda[][] = []
    const clas: (Clasificacion | null)[] = []
    for (const g of gruposSemaforo.value) {
      for (const a of g.hojas) {
        rows.push([`${g.ordinal ?? ''} ${g.nombre}`, (a.ordinal ? a.ordinal + '. ' : '') + a.nombre, fmtVal(a.valoracion), clasLabel(a.clasificacion)])
        clas.push(a.clasificacion)
      }
    }
    return { tabla: { nombre: `${base}_fortalezas`, titulo: 'Fortalezas y Debilidades', headers, rows }, clasFilas: clas }
  }
  // estructura + graficos → export de la estructura completa
  const headers = ['Código', 'Tipo', 'Nombre', 'Ponderación', 'Valoración', '%', 'Grado', 'Clasificación']
  const rows: Celda[][] = []
  const clas: (Clasificacion | null)[] = []
  for (const f of filasEstructura.value) {
    rows.push([f.codigo, f.tipo, f.nombre, f.peso === null ? '—' : fmtPeso(f.peso), fmtVal(f.valoracion), fmtPct(f.pct), f.grado ?? '—', clasLabel(f.clasificacion)])
    clas.push(f.clasificacion)
  }
  return { tabla: { nombre: `${base}_estructura`, titulo: 'Estructura Completa de Resultados', headers, rows }, clasFilas: clas }
}

function colorFilaExport(clas: (string | null)[]) {
  const map: Record<string, [number, number, number]> = {
    fuerte:    [212, 237, 218],
    debil:     [255, 243, 205],
    muy_debil: [248, 215, 218],
    no_aplica: [240, 240, 240],
    subtotal:  [200, 223, 245],
    global:    [220, 239, 255]
  }
  return (i: number) => {
    const c = clas[i]
    return c && map[c] ? map[c] : null
  }
}

function boldFilaExport(clas: (string | null)[]) {
  return (i: number) => clas[i] === 'subtotal' || clas[i] === 'global'
}

async function exportar(formato: 'csv' | 'excel' | 'pdf'): Promise<void> {
  const { tabla, clasFilas, merges } = construirTabla()
  const subtitulo = datos.value ? `${datos.value.modelo?.nombre ?? ''} · Periodo ${datos.value.periodo} · Escala 0–${datos.value.escala_max}` : undefined
  const colorFila = colorFilaExport(clasFilas)
  const boldFila  = boldFilaExport(clasFilas)
  if (formato === 'csv') exportarCSV(tabla)
  else if (formato === 'excel') await exportarExcel(tabla, { colorFila, boldFila, merges })
  else exportarPDF(tabla, { subtitulo, colorFila, boldFila })
}

// Carga
store.cargar(idEjecucion)

onMounted(async () => {
  // Proceso y relaciones de instrumentos en paralelo para no bloquear la carga
  const [proceso] = await Promise.all([
    getProcesoByIdService(idEjecucion),
    indicadorInstrumentoStore.getRelaciones()
  ])
  nombreVersion.value = (proceso as any)?.version?.nombre ?? ''
  idVersion.value = (proceso as any)?.id_version ?? null
  idsConInstrumento.value = new Set(
    indicadorInstrumentoStore.relaciones.map(r => Number(r.id_indicador))
  )
  relacionesCargadas.value = true
})

// ── Edición de notas históricas ───────────────────────────────────────────

function esHistorico(nodo: NodoResultado | null | undefined): boolean {
  if (!nodo || !nodo.es_hoja || nodo.aspectos.length !== 1) return false
  return !idsConInstrumento.value.has(nodo.aspectos[0].id_indicador)
}

function onCambioNota(nodo: NodoResultado, valor: number) {
  const id = nodo.aspectos[0]?.id_indicador
  if (!id) return
  const min = escalaMinimo.value
  const max = escala.value
  notasEditadas.value = {
    ...notasEditadas.value,
    [id]: Math.min(Math.max(isNaN(valor) ? min : valor, min), max)
  }
}

function cancelarEdicion() {
  notasEditadas.value = {}
  modoEdicion.value = false
}

async function guardarModificaciones() {
  const cambios = Object.entries(notasEditadas.value)
  if (!cambios.length) { modoEdicion.value = false; return }

  const idVer = idVersion.value
  const idUsuario = authStore.usuarioActual?.id
  if (!idVer || !idUsuario) {
    mostrarMensaje('No se puede guardar: datos de sesión incompletos.', 'error')
    return
  }

  guardandoCambios.value = true

  // Obtener registros existentes para conseguir id_evaluacion_indicador (PUT no verifica estado del proceso)
  const registros = await getEvaluacionesIndicadorService({
    id_version: idVer,
    id_ejecucion: idEjecucion,
    id_usuario: Number(idUsuario)
  })

  const pkPorIndicador = new Map<number, number>()
  for (const ev of registros) {
    const idInd = ev.id_indicador
    const pk = (ev as any).id_evaluacion_indicador
    if (idInd && pk) pkPorIndicador.set(Number(idInd), Number(pk))
  }

  const min = escalaMinimo.value
  const max = escala.value

  const resultados = await Promise.all(
    cambios.map(([idInd, nota]) => {
      const pk = pkPorIndicador.get(Number(idInd))
      if (!pk) return Promise.resolve({ ok: false })
      const notaClamped = Math.min(Math.max(nota, min), max)
      return evaluacionesStore.actualizar(pk, {
        calificacion_documental: notaClamped,
        calificacion_cuantitativa: notaClamped,
        calificacion_opinion: notaClamped,
        id_usuario_editor: Number(idUsuario)
      })
    })
  )

  if (resultados.some(r => !r.ok)) {
    guardandoCambios.value = false
    mostrarMensaje('No se pudo guardar los cambios. Intente de nuevo.', 'error')
    return
  }

  // Disparar recalculo de consolidación por cada indicador modificado
  await Promise.all(cambios.map(([idInd]) => getResultadoIndicadorService(idVer, Number(idInd))))

  // Recargar el árbol completo de resultados
  await store.cargar(idEjecucion)

  guardandoCambios.value = false
  notasEditadas.value = {}
  modoEdicion.value = false
  mostrarMensaje('Calificaciones actualizadas correctamente.', 'positivo')
}

return (_ctx: any,_cache: any) => {
  const _directive_drag_scroll = _resolveDirective("drag-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[7] || (_cache[7] = _createElementVNode("h1", null, "Resultados de Autoevaluación", -1)),
        (nombreVersion.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(nombreVersion.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_4, [
          _createTextVNode(" Ejecución #" + _toDisplayString(_unref(idEjecucion)) + " ", 1),
          (datos.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" · " + _toDisplayString(datos.value.modelo?.nombre) + " · Periodo " + _toDisplayString(datos.value.periodo) + " · Escala 0–" + _toDisplayString(datos.value.escala_max), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("button", {
        class: "btn salir",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ProcesoAutoevaluacionUsuario' })))
      }, "Volver")
    ]),
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "divider" }, null, -1)),
    (_unref(store).cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Cargando resultados…"))
      : (datos.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(enfoques, (e) => {
                  return _createElementVNode("button", {
                    key: e.id,
                    class: _normalizeClass(["tab", { activo: enfoque.value === e.id }]),
                    onClick: ($event: any) => (enfoque.value = e.id)
                  }, _toDisplayString(e.label), 11, _hoisted_8)
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn ocultar",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (mostrarPanel.value = !mostrarPanel.value))
                }, _toDisplayString(mostrarPanel.value ? 'Cerrar' : 'Mostrar / ocultar'), 1),
                _createElementVNode("button", {
                  class: "btn mod",
                  disabled: !relacionesCargadas.value || _unref(store).cargando || guardandoCambios.value,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (modoEdicion.value ? guardarModificaciones() : (modoEdicion.value = true)))
                }, _toDisplayString(guardandoCambios.value ? 'Guardando…' : modoEdicion.value ? 'Guardar' : 'Modificar'), 9, _hoisted_10),
                (modoEdicion.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn salir",
                      disabled: guardandoCambios.value,
                      onClick: cancelarEdicion
                    }, " Cancelar ", 8, _hoisted_11))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn exp",
                  disabled: modoEdicion.value,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (exportar('csv')))
                }, "CSV", 8, _hoisted_12),
                _createElementVNode("button", {
                  class: "btn exp",
                  disabled: modoEdicion.value,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (exportar('excel')))
                }, "Excel", 8, _hoisted_13),
                _createElementVNode("button", {
                  class: "btn exp",
                  disabled: modoEdicion.value,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (exportar('pdf')))
                }, "PDF", 8, _hoisted_14)
              ])
            ]),
            (mostrarPanel.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _cache[8] || (_cache[8] = _createElementVNode("p", { class: "panel-titulo" }, "Ocultar factores y características de la hoja", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factoresOrdenados.value, (f) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: f.id_componente,
                      class: "panel-factor"
                    }, [
                      _createElementVNode("label", _hoisted_16, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: !estaOculto(f.id_componente),
                          onChange: ($event: any) => (toggle(f.id_componente))
                        }, null, 40, _hoisted_17),
                        _createElementVNode("strong", null, _toDisplayString(fmtOrdinal(f.ordinal)) + " " + _toDisplayString(f.nombre), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(f.hijos, (c) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: c.id_componente,
                            class: "chk"
                          }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: !estaOculto(c.id_componente),
                              onChange: ($event: any) => (toggle(c.id_componente))
                            }, null, 40, _hoisted_19),
                            _createTextVNode(" " + _toDisplayString(fmtOrdinal(c.ordinal)) + " " + _toDisplayString(c.nombre), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("table", _hoisted_21, [
                _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "N°"),
                    _createElementVNode("th", null, "Factor"),
                    _createElementVNode("th", null, "Ponderación"),
                    _createElementVNode("th", null, "N° C."),
                    _createElementVNode("th", null, "Característica"),
                    _createElementVNode("th", null, "N° A."),
                    _createElementVNode("th", null, "Aspecto"),
                    _createElementVNode("th", { class: "col-num" }, "Valoración"),
                    _createElementVNode("th", { class: "col-num" }, "Gradación"),
                    _createElementVNode("th", { class: "col-num" }, "% Prom. Ponderado"),
                    _createElementVNode("th", null, "Nivel de Cumplimiento")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filasGenerales.value, (fila) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: fila.key
                    }, [
                      (fila.tipo === 'aspecto')
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                            (fila.mostrarFactor)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 0,
                                  rowspan: fila.factorRowspan,
                                  class: "celda-factor"
                                }, _toDisplayString(fmtOrdinal(fila.factor.ordinal)), 9, _hoisted_23))
                              : _createCommentVNode("", true),
                            (fila.mostrarFactor)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 1,
                                  rowspan: fila.factorRowspan,
                                  class: "celda-factor nombre"
                                }, _toDisplayString(fila.factor.nombre), 9, _hoisted_24))
                              : _createCommentVNode("", true),
                            (fila.mostrarFactor)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 2,
                                  rowspan: fila.factorRowspan,
                                  class: "celda-factor col-num"
                                }, _toDisplayString(fmtPeso(fila.factor.peso)), 9, _hoisted_25))
                              : _createCommentVNode("", true),
                            (fila.caract)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  (fila.mostrarCaract)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 0,
                                        rowspan: fila.caractRowspan
                                      }, _toDisplayString(fmtOrdinal(fila.caract.ordinal)), 9, _hoisted_26))
                                    : _createCommentVNode("", true),
                                  (fila.mostrarCaract)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 1,
                                        rowspan: fila.caractRowspan,
                                        class: "nombre"
                                      }, _toDisplayString(fila.caract.nombre), 9, _hoisted_27))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _cache[9] || (_cache[9] = _createElementVNode("td", null, null, -1)),
                                  _cache[10] || (_cache[10] = _createElementVNode("td", { class: "nombre" }, "—", -1))
                                ], 64)),
                            _createElementVNode("td", null, _toDisplayString(fmtOrdinal(fila.aspecto?.ordinal)), 1),
                            _createElementVNode("td", _hoisted_28, _toDisplayString(fila.aspecto?.nombre ?? '—'), 1),
                            _createElementVNode("td", _hoisted_29, [
                              (modoEdicion.value && fila.aspecto && esHistorico(fila.aspecto))
                                ? (_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "number",
                                    class: "input-nota",
                                    min: escalaMinimo.value,
                                    max: escala.value,
                                    step: "0.01",
                                    value: notasEditadas.value[fila.aspecto.aspectos[0].id_indicador] ?? fila.aspecto.valoracion ?? 0,
                                    onChange: ($event: any) => (onCambioNota(fila.aspecto, +($event.target as HTMLInputElement).value))
                                  }, null, 40, _hoisted_30))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(fmtVal(fila.aspecto?.valoracion ?? null)), 1)
                                  ], 64))
                            ]),
                            (fila.caract && fila.mostrarCaract)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 5,
                                  rowspan: fila.caractRowspan,
                                  class: "col-num"
                                }, _toDisplayString(fmtPeso(fila.caract.peso)), 9, _hoisted_31))
                              : (!fila.caract)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_32, "—"))
                                : _createCommentVNode("", true),
                            (fila.caract && fila.mostrarCaract)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 7,
                                  rowspan: fila.caractRowspan,
                                  class: "col-num"
                                }, _toDisplayString(fmtVal(fila.caract.valoracion)), 9, _hoisted_33))
                              : (!fila.caract)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_34, "—"))
                                : _createCommentVNode("", true),
                            _createElementVNode("td", {
                              class: _normalizeClass(["nivel", clasClase(fila.aspecto?.clasificacion ?? 'no_aplica')])
                            }, _toDisplayString(fila.aspecto?.grado ?? '—'), 3)
                          ]))
                        : (_openBlock(), _createElementBlock("tr", _hoisted_35, [
                            _createElementVNode("td", _hoisted_36, "SUBTOTAL FACTOR " + _toDisplayString(fmtOrdinal(fila.factor.ordinal)) + " · " + _toDisplayString(fila.factor.nombre), 1),
                            _createElementVNode("td", _hoisted_37, _toDisplayString(fmtVal(fila.factor.valoracion)), 1),
                            _createElementVNode("td", _hoisted_38, _toDisplayString(fmtPeso(fila.factor.peso)), 1),
                            _createElementVNode("td", _hoisted_39, _toDisplayString(fmtPct(fila.factor.pct)), 1),
                            _createElementVNode("td", {
                              class: _normalizeClass(["nivel", clasClase(fila.factor.clasificacion)])
                            }, _toDisplayString(fila.factor.grado ?? '—'), 3)
                          ]))
                    ], 64))
                  }), 128)),
                  (datos.value.global)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                        _cache[11] || (_cache[11] = _createElementVNode("td", { colspan: "7" }, "CALIFICACIÓN GLOBAL DEL MODELO", -1)),
                        _createElementVNode("td", _hoisted_41, _toDisplayString(fmtVal(datos.value.global.valoracion)), 1),
                        _cache[12] || (_cache[12] = _createElementVNode("td", { class: "col-num" }, "100%", -1)),
                        _createElementVNode("td", _hoisted_42, _toDisplayString(fmtPct(datos.value.global.pct)), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(["nivel", clasClase(datos.value.global.clasificacion)])
                        }, _toDisplayString(datos.value.global.grado ?? '—'), 3)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])), [
              [_vShow, enfoque.value === 'general'],
              [_directive_drag_scroll]
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datos.value.resumen, (r, k) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: k,
                    class: "resumen-card"
                  }, [
                    _createElementVNode("span", _hoisted_44, _toDisplayString(nivelLabel(k)), 1),
                    _createElementVNode("div", _hoisted_45, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "pt fuerte" }, null, -1)),
                      _cache[15] || (_cache[15] = _createTextVNode(" Fuertes ")),
                      _createElementVNode("b", null, _toDisplayString(r.fuerte), 1),
                      _cache[16] || (_cache[16] = _createTextVNode()),
                      _createElementVNode("small", null, "(" + _toDisplayString(pctResumen(r.fuerte, r.total)) + ")", 1)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "pt debil" }, null, -1)),
                      _cache[18] || (_cache[18] = _createTextVNode(" Débiles ")),
                      _createElementVNode("b", null, _toDisplayString(r.debil), 1),
                      _cache[19] || (_cache[19] = _createTextVNode()),
                      _createElementVNode("small", null, "(" + _toDisplayString(pctResumen(r.debil, r.total)) + ")", 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "pt muy_debil" }, null, -1)),
                      _cache[21] || (_cache[21] = _createTextVNode(" Muy débiles ")),
                      _createElementVNode("b", null, _toDisplayString(r.muy_debil), 1),
                      _cache[22] || (_cache[22] = _createTextVNode()),
                      _createElementVNode("small", null, "(" + _toDisplayString(pctResumen(r.muy_debil, r.total)) + ")", 1)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _cache[23] || (_cache[23] = _createElementVNode("span", { class: "pt no_aplica" }, null, -1)),
                      _cache[24] || (_cache[24] = _createTextVNode(" No aplica ")),
                      _createElementVNode("b", null, _toDisplayString(r.no_aplica), 1)
                    ])
                  ]))
                }), 128))
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_49, [
                _createElementVNode("table", _hoisted_50, [
                  _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Característica"),
                      _createElementVNode("th", null, "Aspecto"),
                      _createElementVNode("th", { class: "col-num" }, "Valoración"),
                      _createElementVNode("th", { class: "col-sem" }, "Fuerte"),
                      _createElementVNode("th", { class: "col-sem" }, "Débil"),
                      _createElementVNode("th", { class: "col-sem" }, "Muy débil")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gruposSemaforo.value, (grupo) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: grupo.id
                      }, [
                        _createElementVNode("tr", _hoisted_51, [
                          _createElementVNode("td", _hoisted_52, _toDisplayString(fmtOrdinal(grupo.ordinal)) + " " + _toDisplayString(grupo.nombre), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.hojas, (a) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: grupo.id + '-' + a.id_componente
                          }, [
                            _cache[25] || (_cache[25] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", _hoisted_53, _toDisplayString((a.ordinal ? fmtOrdinal(a.ordinal) + '. ' : '') + a.nombre), 1),
                            _createElementVNode("td", _hoisted_54, _toDisplayString(fmtVal(a.valoracion)), 1),
                            _createElementVNode("td", _hoisted_55, [
                              (a.clasificacion === 'fuerte')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_56))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_57, [
                              (a.clasificacion === 'debil')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_58))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_59, [
                              (a.clasificacion === 'muy_debil')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_60))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ], 64))
                    }), 128))
                  ])
                ])
              ])), [
                [_directive_drag_scroll]
              ])
            ], 512), [
              [_vShow, enfoque.value === 'fortalezas']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createElementVNode("table", _hoisted_62, [
                _cache[27] || (_cache[27] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Código"),
                    _createElementVNode("th", null, "Tipo"),
                    _createElementVNode("th", null, "Nombre"),
                    _createElementVNode("th", { class: "col-num" }, "Ponderación"),
                    _createElementVNode("th", { class: "col-num" }, "Valoración"),
                    _createElementVNode("th", { class: "col-num" }, "%"),
                    _createElementVNode("th", null, "Grado"),
                    _createElementVNode("th", null, "Clasificación")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filasEstructura.value, (f) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: f.key,
                      class: _normalizeClass('nivel-' + f.tipoNivel)
                    }, [
                      _createElementVNode("td", _hoisted_63, _toDisplayString(fmtOrdinal(f.codigo)), 1),
                      _createElementVNode("td", null, _toDisplayString(f.tipo), 1),
                      _createElementVNode("td", _hoisted_64, _toDisplayString(f.nombre), 1),
                      _createElementVNode("td", _hoisted_65, _toDisplayString(f.peso === null ? '—' : fmtPeso(f.peso)), 1),
                      _createElementVNode("td", _hoisted_66, _toDisplayString(fmtVal(f.valoracion)), 1),
                      _createElementVNode("td", _hoisted_67, _toDisplayString(fmtPct(f.pct)), 1),
                      _createElementVNode("td", null, _toDisplayString(f.grado ?? '—'), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge-clas", clasClase(f.clasificacion)])
                        }, _toDisplayString(clasLabel(f.clasificacion)), 3)
                      ])
                    ], 2))
                  }), 128))
                ])
              ])
            ])), [
              [_vShow, enfoque.value === 'estructura'],
              [_directive_drag_scroll]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_68, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datosGraficos.value, (g) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: g.id,
                  class: "grafico-card"
                }, [
                  _createElementVNode("h3", _hoisted_69, "Factor " + _toDisplayString(fmtOrdinal(g.ordinal)) + ": " + _toDisplayString(g.nombre), 1),
                  (_openBlock(), _createElementBlock("svg", {
                    viewBox: `0 0 ${g.width} 200`,
                    class: "grafico-svg",
                    preserveAspectRatio: "xMidYMid meet"
                  }, [
                    _cache[28] || (_cache[28] = _createElementVNode("line", {
                      x1: "38",
                      y1: "10",
                      x2: "38",
                      y2: "160",
                      stroke: "#ccc"
                    }, null, -1)),
                    _createElementVNode("line", {
                      x1: "38",
                      y1: "160",
                      x2: g.width - 10,
                      y2: "160",
                      stroke: "#ccc"
                    }, null, 8, _hoisted_71),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ejeTicks.value, (t) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: 't' + t
                      }, [
                        _createElementVNode("line", {
                          x1: "34",
                          y1: yPos(t),
                          x2: "38",
                          y2: yPos(t),
                          stroke: "#999"
                        }, null, 8, _hoisted_72),
                        _createElementVNode("text", {
                          x: "30",
                          y: yPos(t) + 3,
                          "text-anchor": "end",
                          class: "eje-label"
                        }, _toDisplayString(t), 9, _hoisted_73)
                      ], 64))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.barras, (b, i) => {
                      return (_openBlock(), _createElementBlock("g", {
                        key: 'b' + i
                      }, [
                        _createElementVNode("rect", {
                          x: 48 + i * g.paso,
                          y: yPos(b.valor ?? 0),
                          width: g.anchoBarra,
                          height: 160 - yPos(b.valor ?? 0),
                          fill: clasColor(b.clasificacion),
                          rx: "2"
                        }, null, 8, _hoisted_74),
                        _createElementVNode("text", {
                          x: 48 + i * g.paso + g.anchoBarra / 2,
                          y: yPos(b.valor ?? 0) - 4,
                          "text-anchor": "middle",
                          class: "barra-val"
                        }, _toDisplayString(b.valor === null ? '—' : b.valor.toFixed(2)), 9, _hoisted_75),
                        _createElementVNode("text", {
                          x: 48 + i * g.paso + g.anchoBarra / 2,
                          y: "174",
                          "text-anchor": "middle",
                          class: "barra-label"
                        }, _toDisplayString(fmtOrdinal(b.ordinal)), 9, _hoisted_76)
                      ]))
                    }), 128))
                  ], 8, _hoisted_70))
                ]))
              }), 128)),
              (!datosGraficos.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_77, "No hay factores visibles para graficar."))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, enfoque.value === 'graficos']
            ])
          ], 64))
        : _createCommentVNode("", true),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[6] || (_cache[6] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})